export const DISPLAY_LOADING = "DISPLAY_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"